export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40435e6aaad66696bfca862490bb0c7f93cfcbc120&name=revalidateCommunity!'